/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$S as $S,
  rec_DetalleTarea as DetalleTarea,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_Pi as Pi,
  rec_React as React,
  rec_TarjetaTarea as TarjetaTarea,
  rec_Ti as Ti,
  rec_api as api,
  rec_eC as eC,
  rec_mS as mS,
  rec_obtenerUsuario as obtenerUsuario,
  rec_st as st,
  rec_usuarioIdSesion as usuarioIdSesion,
} from "../../runtime/index.jsx";
export function MenuCrear() {
  let e = st(),
    t = Go(),
    [n, r] = (0, React.useState)(!1),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(null),
    [c, l] = (0, React.useState)(null),
    { resultados: u, buscando: f } = $S(i);
  (0, React.useEffect)(() => {
    let e = (e) => {
      (e.ctrlKey || e.metaKey) &&
        e.key.toLowerCase() === `k` &&
        (e.preventDefault(), r(!0));
    };
    return (
      window.addEventListener(`keydown`, e),
      () => window.removeEventListener(`keydown`, e)
    );
  }, []);
  function p() {
    (r(!1), a(``));
  }
  async function m() {
    try {
      let e = await api(
        `/proyectos/personal?nombre=${encodeURIComponent(obtenerUsuario()?.nombre ?? ``)}`,
      );
      (p(), s(e));
    } catch (e) {
      t.error(e.message);
    }
  }
  function h(t) {
    (p(), t.tipo === `TAREA` ? l(t.id) : e(mS(t)));
  }
  return (
    <JSXRuntime.Fragment
      children={[
        <button
          type={`button`}
          onClick={() => r(!0)}
          aria-label={`Nueva tarea o buscar`}
          className={`fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-(--accent) text-(--accent-fg) shadow-[var(--sombra-flotante)] transition duration-150 ease-(--curva) active:scale-[0.92] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) sm:hidden`}
          children={<Ti className={`h-6 w-6`} />}
        />,
        n && (
          <Modal
            titulo={`¿Qué querés hacer?`}
            onClose={p}
            children={
              <div
                className={`flex flex-col gap-3`}
                children={[
                  <button
                    type={`button`}
                    onClick={m}
                    className={`flex items-center gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) px-3 py-3 text-left text-sm font-medium text-(--text-h) transition duration-150 ease-(--curva) active:scale-[0.99]`}
                    children={[
                      <Ti className={`h-4 w-4 shrink-0 text-(--accent)`} />,
                      `Anotar una tarea`,
                    ]}
                  />,
                  <div
                    className={`relative`}
                    children={[
                      <Pi
                        className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text)`}
                      />,
                      <input
                        autoFocus={!0}
                        value={i}
                        onChange={(e) => a(e.target.value)}
                        placeholder={`Buscar una tarea, un proyecto, una reunión…`}
                        className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) pl-9`}
                      />,
                    ]}
                  />,
                  i.trim().length >= 2 && (
                    <div
                      className={`max-h-72 overflow-y-auto rounded-2xl border border-(--border)`}
                      children={
                        f ? (
                          <p
                            className={`px-3 py-4 text-center text-sm text-(--text)`}
                            children={`Buscando…`}
                          />
                        ) : u.length === 0 ? (
                          <p
                            className={`px-3 py-4 text-center text-sm text-(--text)`}
                            children={`No encontré nada con eso.`}
                          />
                        ) : (
                          <ul
                            children={u.map((e) => (
                              <li
                                key={`${e.tipo}-${e.id}`}
                                children={
                                  <button
                                    type={`button`}
                                    onClick={() => h(e)}
                                    className={`flex w-full flex-col items-start gap-0.5 border-b border-(--border) px-3 py-2 text-left transition last:border-0 hover:bg-(--accent-bg)`}
                                    children={[
                                      <span
                                        className={`flex w-full items-center gap-2`}
                                        children={[
                                          <span
                                            className={`rounded bg-(--panel) px-1.5 py-0.5 text-[10px] uppercase text-(--text)`}
                                            children={eC[e.tipo] ?? e.tipo}
                                          />,
                                          <span
                                            className={`min-w-0 flex-1 truncate text-sm text-(--text-h)`}
                                            children={e.titulo}
                                          />,
                                        ]}
                                      />,
                                      e.tipo !== `PROYECTO` && (
                                        <span
                                          className={`text-xs text-(--text)`}
                                          children={e.proyectoNombre}
                                        />
                                      ),
                                    ]}
                                  />
                                }
                              />
                            ))}
                          />
                        )
                      }
                    />
                  ),
                  <p
                    className={`hidden text-center text-xs text-(--text) sm:block`}
                    children={[
                      `Se abre con `,
                      <kbd
                        className={`rounded border border-(--border) px-1`}
                        children={`Ctrl`}
                      />,
                      ` +`,
                      ` `,
                      <kbd
                        className={`rounded border border-(--border) px-1`}
                        children={`K`}
                      />,
                    ]}
                  />,
                ]}
              />
            }
          />
        ),
        o && (
          <DetalleTarea
            proyecto={o}
            preset={{
              asignadoUsuarioId: usuarioIdSesion(),
              asignadoNombre: obtenerUsuario()?.nombre ?? ``,
              asignadoCorreo: obtenerUsuario()?.correo ?? ``,
            }}
            onClose={() => s(null)}
            onGuardado={() => s(null)}
          />
        ),
        c && <TarjetaTarea tareaId={c} onClose={() => l(null)} />,
      ]}
    />
  );
}
